import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
import { login } from "../api/authentication";

export const getLoginData = createAsyncThunk(
  "auth/loginData",
  async (values, { rejectWithValue }) => {
    try {
      // console.log("Login request initiated with values:", values);
      const { data } = await login(values); // API call
      // console.log("API Response:", data);
      return data;
    } catch (error) {
      console.error("Login failed:", error.response?.data || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialValues = {
  user: null,
  isLoading: false,
  isError: null,
  status: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialValues,
  extraReducers: (builder) => {
    builder
      .addCase(getLoginData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload;
        state.status = true;
        state.isError = null;
        // Store user details in cookies
        Cookies.set("token", action.payload.data?.access_token, {
          secure: true,
        });
        Cookies.set(
          "personal_token",
          action.payload.data?.personal_access_token,
          {
            secure: true,
          }
        );
        // Cookies.set("branch_id", action.payload.data?.user_branch, {
        //   secure: true,
        // });
        // Cookies.set("user_id", action.payload.data?.user_id, { secure: true });
        // sessionStorage.setItem("token", action.payload.data?.access_token);
        Cookies.set("brunch_id", action.payload.data?.user_branch, {
          secure: true,
        });
        sessionStorage.setItem("user_id", action.payload.data?.user_id); // Add user_id
      })
      .addCase(getLoginData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLoginData.rejected, (state, action) => {
        state.isError = action.payload;
        state.isLoading = false;
        state.user = null;
        state.status = false;
      });
  },
  reducers: {},
});

export const authReducer = authSlice.reducer;
